import React, { useEffect } from "react";
import { useQuery } from "react-query";
import Container from "../lib/Container/Container";
import { ButtonWithIcon } from "../lib";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";

import WomenListTable from "./WomenListTable";
import { getWomenFanCard } from "../../../api/womenFanCard/womenFanCardApi";

const WomenFanCardList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const [queryString, setQueryString] = React.useState<{
    page: number;
    search: string;
    filter: string ;
    numberInPage: number;
  }>({
    page,
    search: "",
    filter: "",
    numberInPage: 5,
  });

  const { data, isLoading, isError, error, refetch } = useQuery(
    ["WomenFanCard"],
    () =>
      getWomenFanCard(
        queryString.page,
        queryString.search,
        queryString.filter,
        queryString.numberInPage,
        "pending"
      )
  );

  const setQSandEnable = (values) => {
    setQueryString(values);
  };

  const setQS = (page) => {
    //@ts-ignore
    setSearchParams({ page });
    setQueryString((state) => ({
      ...state,
      page: page,
    }));
  };

  useEffect(() => {
    if (queryString.page) {
      refetch();
    }
  }, [queryString.page]);

  useEffect(() => {
    if (queryString.search) {
      setQueryString((state) => ({
        ...state,
        page: 1,
      }));
    }
  }, [queryString.search]);

  useEffect(() => {
    if (queryString.page === 1) {
      refetch();
    }
  }, [queryString.search]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: </div>;

  return (
    <Container className={"bg-white p-0 mt-10"}>
      {/*Header Start*/}
      <div
        className={
          "d-flex align-items-center justify-content-between table-header"
        }
      >
        <div className={"d-flex align-items-center gap-4"}>
          <SearchForm
            onSubmitCallback={(searchTerm) => {
              setQSandEnable({ ...queryString, search: searchTerm });
            }}
            searchTerm={queryString.search}
          />
        </div>
      </div>

      {/*Table Start*/}
      {/*@ts-ignore*/}
      {data?.fanCards?.length ? (
        <WomenListTable
          queryString={queryString}
          setQueryString={setQS}
          data={data}
          refetch={refetch}
          numberInPage={queryString.numberInPage}
        />
      ) : (
        <p className={"p-2 m-2"}>فیلدی با این خصوصیات پیدا نشد. </p>
      )}
    </Container>
  );
};

const SearchForm = ({ onSubmitCallback, searchTerm }) => {
  const initialValues = {
    searchTerm: searchTerm || "", // Set initial value from prop if provided
  };

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);

    // Call the onSubmitCallback if provided
    if (onSubmitCallback && typeof onSubmitCallback === "function") {
      onSubmitCallback(values.searchTerm);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isSubmitting, handleChange, values }) => (
        <Form
          className={"d-flex align-items-center gap-3"}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Field
            type="text"
            name="searchTerm"
            className="border rounded p-2 bg-white w-c-130 text-right"
            placeholder="جستجو"
            onChange={handleChange}
            value={values.searchTerm}
          />
          <ErrorMessage
            name="searchTerm"
            component="div"
            className="text-red-600"
          />
          <ButtonWithIcon
            btnText="جستجو"
            iconName="magnifier"
            type="submit"
            disabled={isSubmitting}
          />
        </Form>
      )}
    </Formik>
  );
};

export default WomenFanCardList;
